import React from 'react';

import ConnectImg from '../../../../images/demo/connect.png';
import GraphImg from '../../../../images/demo/graph.png';
import NoteImg from '../../../../images/demo/note.png';
import TryforFreeButton from '../../../component/TryforFreeButton';
import VideoJS from '../../../component/VideoJs';

const lists = [
  {
    id: '1',
    icon: ConnectImg,
    description: 'Social media report in seconds'
  },
  {
    id: '2',
    icon: GraphImg,
    description: 'Real-time analytics & insights'
  },
  {
    id: '3',
    icon: NoteImg,
    description: 'Track profiles across platforms'
  }
]

const Demo = () => {

  const videoJsOptions = {
    controls: true,
    responsive: true,
    fluid: true,
    fill: true,
    sources: [{
      src: 'https://outstrip-media-assets.s3.ap-south-1.amazonaws.com/outstrip-demo.mp4',
      type: 'video/mp4'
    }]
  };



  const renderGrid = () => (
    <div className='mx-12 md:mx-44 my-10 md:my-20 md:grid grid-flow-col grid-cols-2'>
      <div className='px-2 md:px-12 py-6'>
        <h1 className='text-3xl md:text-6xl text-gradient'>It&apos;s time your reports became self-sufficient!</h1>
        <p className='text-xl md:text-3xl mt-6'>Sneak peek into the dynamic features of our agile tool</p>
      </div>
      <div>
        <VideoJS options={videoJsOptions} />
      </div>
    </div>
  );

  const renderList = (list) => {
    return (
      <div key={list.id} className='flex justify-center items-center px-6'>
        <div>
          <img src={list.icon} />
        </div>
        <div className='p-4'>{list.description}</div>
      </div>
    );
  }

  const renderLists = () => {
    return <div className='md:flex justify-center items-center'>{lists.map(renderList)}</div>
  }

  const renderGradientContent = () => {
    return (
      <div className='px-10 md:px-20 py-20 my-12 bg-rose-gradient'>
        {renderLists()}
        <p className='my-12 text-center text-2xl'>Our platform will create your report while you watch this video</p>
        <div className='text-center'>
          <TryforFreeButton content='Create report now' />
        </div>
      </div>
    );
  }

  return (
    <div className='' id='demoContainer'>
      {renderGrid()}
      {renderGradientContent()}
    </div>
  );
}

export default Demo;